import './CenteredLoader.css';
import { constants } from '../Utils/constants';
import { useTranslation } from 'react-i18next';

export const CenteredLoader = () => {
    const { t } = useTranslation();
    return (
        <div className='container hurme-3-regular letter-spacing'>
            <div className='centered-loader-pg-container'>
            <h1 className='centered-loader-pg-h1'>{t("please_wait")}</h1>
            <img className='centered-loader-img' src={constants.ASSET_URLS.LOADER} alt="Loading. Please wait." />
            </div>
        </div>
    )
}